window.MarketingDetails = (function() {

    "use strict";

    var queryParams = {
        page: 1
    };

    var currentUserId;

    function getData(route, userId, template, callback) {
        $.ajax({
            url: route + userId,
            type: 'GET',
            data: buildQueryParams(),
            success: function(data, txt, xhr){
                if((xhr.status >= 200 && xhr.status < 400) || data.status == 1 && typeof callback === 'function'){
                    currentUserId = userId;
                    callback(data, template);
                }
            }
        });
    }

    function renderTemplate(data, template) {
        var $listingPanel = $('.js-mo-details-body')
        var template = Handlebars.compile($(template).html());

        $listingPanel.html(template(data));
    }

    function renderFlyerTemplate(data, template) {
        var $listingPanel = $('.js-mo-details-body')
        var template = Handlebars.compile($(template).html());

        $listingPanel.html(template(data));
    }

    function renderPostcardTemplate(data, template) {
        var $listingPanel = $('.js-mo-details-body')
        var template = Handlebars.compile($(template).html());

        $listingPanel.html(template(data));
    }

    function renderPagerTemplate(data, template) {
        var $listingPanel = $('.js-mo-details-body')
        var template = Handlebars.compile($(template).html());

        $listingPanel.html(template(data));
        pagination(data);
    }

    function triggerModal() {
        $('.data-table-mo').on('click' ,'.js-connections-sent-details', function() {
            var userId = $(this).attr('data-user-id');

            getData('/marketing-details/connections-sent/', userId, '#mo-connections-sent-details', renderTemplate);
        }).on('click' ,'.js-connections-accepted-details', function() {
            var userId = $(this).attr('data-user-id');

            getData('/marketing-details/connections-accepted/', userId, '#mo-connections-accepted-details', renderTemplate);
        }).on('click' ,'.js-emails-sent-details', function() {
            var userId = $(this).attr('data-user-id');

            getData('/marketing-details/emails-sent/', userId, '#mo-email-list', renderPagerTemplate);
        }).on('click', '.js-active-site-details', function() {
            var userId = $(this).attr('data-user-id');

            getData('/marketing-details/active-sites/', userId, '#mo-active-sites-list', renderTemplate);
        }).on('click' ,'.js-flyer-details', function() {
            var userId = $(this).attr('data-user-id');
            queryParams.type = 1;

            getData('/marketing-details/media-details/', userId, '#mo-print-media-list', renderFlyerTemplate);
        }).on('click' ,'.js-postcard-details', function() {
            var userId = $(this).attr('data-user-id');
            queryParams.type = 'postcard';

            getData('/marketing-details/media-details/', userId, '#mo-print-media-list', renderPostcardTemplate);
        });

        $('.js-mo-details-body').on('click', '#js-next-page', function(e) {
            nextPage(getData);
        });

        $('.js-mo-details-body').on('click', '#js-prev-page', function(e) {
            prevPage(getData);
        });

        $('#mo-details-modal').on('hide.bs.modal', function() {
            resetQueryParams();
        });
    }

    function pagination(data) {
        var currentPage = parseInt(data.meta.current_page);
        var totalPages = parseInt(data.meta.total_pages);

        if (currentPage == 1) {
            $('#js-prev-page').addClass('hidden');
        } else {
            $('#js-prev-page').removeClass('hidden');
        }

        if (currentPage + 1 > totalPages) {
            $('#js-next-page').addClass('hidden');
        } else {
            $('#js-next-page').removeClass('hidden');            
        }

        if (totalPages < 1) {
            $('.pagination-count').addClass('hidden');
        } else {
            $('.pagination-count').removeClass('hidden');
        }
    }

    function buildQueryParams() {
        if (typeof dataTableAjax !== 'undefined') {
            dataTableAjax.setParams(queryParams);
        }
        return queryParams
    }

    function resetQueryParams() {
        queryParams = {
            page: 1
        };
    }

    function nextPage(callback) {
        queryParams.page = parseInt(queryParams.page) + 1;
        callback('/marketing-details/emails-sent/', currentUserId, '#mo-email-list', renderPagerTemplate);
    }

    function prevPage(callback) {
        queryParams.page = parseInt(queryParams.page) - 1;
        callback('/marketing-details/emails-sent/', currentUserId, '#mo-email-list', renderPagerTemplate);
    }

    function startPanelSpinner(element) {
        var $element  = $(element);

        $element.empty();
        if (!$element.hasClass('panel-loading')) {
            var spinnerHtml = '<div class="panel-loader fade in m-t-15 m-b-15"><span class="spinner spinner-small"></span></div>';
            $element.addClass('panel-loading');
            $element.prepend(spinnerHtml);
        }
    }

    function stopPanelSpinner(element) {
        var $element  = $(element);

        $element.removeClass('panel-loading');
        $element.find('.panel-loader').remove();
    }

    function exportDetailReports() {
        $('.js-export-active-connections').on('click', function() {
            $.get('/marketing-details/export-connections', function(data) {
                JSONToCSVConvertor(data.connections, "Active Connections", true);
            });
        });

        $('.js-export-active-sites').on('click', function() {
            $.get('/marketing-details/export-sites', function(data) {
                JSONToCSVConvertor(data.sites, "Active Sites", true);
            });
        });

        $('.js-export-media').on('click', function() {
            $.get('/marketing-details/export-flyers', function(data) {
                JSONToCSVConvertor(data.media, "Published Flyers", true);
            });
        });


        $('.js-export-team-active-connections').on('click', function() {
            var pageId = $(this).attr('data-page-id');

            $.get('/marketing-details/export-team-connections/' + pageId, function(data) {
                JSONToCSVConvertor(data.connections, "Active Connections", true);
            });
        });

        $('.js-export-team-active-sites').on('click', function() {
            var pageId = $(this).attr('data-page-id');

            $.get('/marketing-details/export-team-sites/' + pageId, function(data) {
                JSONToCSVConvertor(data.sites, "Active Sites", true);
            });
        });

        $('.js-export-team-media').on('click', function() {
            var pageId = $(this).attr('data-page-id');

            $.get('/marketing-details/export-team-flyers/' + pageId, function(data) {
                JSONToCSVConvertor(data.media, "Published Flyers", true);
            });
        });
        
    }

    function init() {
        triggerModal();
        exportDetailReports();

        $(document).ajaxStart(function () {
            startPanelSpinner('.js-mo-details-body');
        }).ajaxStop(function () {
            stopPanelSpinner('.js-mo-details-body');
        });
    }

    return {
        init: init,
        getData: getData,
        queryParams: queryParams
    }

})();
    